var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "acl",
          rawName: "v-acl.show",
          value: { permission: "create", on: "OneOffRequest" },
          expression: "{permission: 'create', on: 'OneOffRequest'}",
          modifiers: { show: true },
        },
      ],
    },
    [
      _vm.piiAuthorized
        ? _c(
            "el-button",
            {
              staticClass: "nav-action",
              staticStyle: { padding: "10px 25px" },
              attrs: { type: "primary", round: "" },
              on: {
                click: function ($event) {
                  return _vm.openForm()
                },
              },
            },
            [_vm._v("\n    " + _vm._s(_vm.$t("common.one_off")) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("one-off-modal-form", { ref: "one_off" }),
      _vm._v(" "),
      _vm.oneOffFormVisible
        ? _c("one-off-flow", {
            attrs: { visible: _vm.oneOffFormVisible },
            on: {
              "update:visible": function ($event) {
                _vm.oneOffFormVisible = $event
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }